// Module
var code = "<div class=\"view-code-editor\"> <div class=\"editor\"></div> </div> ";
// Exports
export default code;